import { render, staticRenderFns } from "./NovaNavbar.vue?vue&type=template&id=7fafa102&scoped=true&lang=pug&"
import script from "./NovaNavbar.vue?vue&type=script&lang=js&"
export * from "./NovaNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NovaNavbar.vue?vue&type=style&index=0&id=7fafa102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fafa102",
  null
  
)

export default component.exports